import type { PanelConfig } from "./types";

export const getPanelConfigByKey = (
  key: string,
  panels: PanelConfig[],
): PanelConfig | undefined => {
  return panels.find((panel) => panel.key === key);
};
